import CustomError from '../CustomError/CustomError';
import errors from '../../shared/utils/errors';
import { t } from 'i18next';
import { useAppSelector } from '../../shared/redux/store';
import React from 'react';

interface ErrorHandlerProps {
  children?: React.ReactElement
}

export const ErrorHandler:React.FC<ErrorHandlerProps> = ({ children }) => {
  const state = useAppSelector((state) => state.errorHandler);

  if (!state.error) {
    return children || null;
  }

  return (
    state.statusCode
      ? <CustomError
        open
        header={errors[state.statusCode].header}
        img={errors[state.statusCode].svg}
        title={t(errors[state.statusCode].title)}
        message={t(errors[state.statusCode].message)}
        buttonText={t(errors[state.statusCode].buttonText)}
      />
      : null
  );
};
